import { Box, Button, IconButton } from '@mui/material';
import { useState } from 'react';
import CustomModal from '../../Common/CustomModal';
import AssignActivityContainer from '../../AssignActivityContainer/AssignActivityContainer';
import { IActivity } from '../../../redux/activity/activitySlice';
import { useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/rootReducer';
import createPermissionCheckers from '../../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../../types/commonTypes';

// TODO: make compatible with new API
function RowOperation({ row }: { row: IActivity }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const isActiveClient = useAppSelector(
    (state: RootState) => state.client.selectedClient?.isActive
  );

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <Box display="flex" gap={2} justifyContent="flex-end" width="100%" mr="24px">
      <IconButton
        disabled={
          !checkPermissions(UserPermissionType.ACTIVITY_MODULE_EDIT_ACTIVITY) || !isActiveClient
        }
        onClick={handleOpenModal}
      >
        <img src="/assets/icons/pen-bold.svg" alt="pencil-icon" role="presentation" />
      </IconButton>
      <CustomModal isOpen={isModalOpen} xs={5}>
        <AssignActivityContainer
          handleBack={handleCloseModal}
          closeModel={handleCloseModal}
          existingActivityData={row}
          isEditMode
        />
      </CustomModal>
    </Box>
  );
}

export default RowOperation;
